<template>
  <div>
    <div v-if="smartAccountNetworks.length === 0" class="flex flex-col gap-y-4">
      <div class="flex flex-col gap-y-1">
        <p class="text-base font-normal text-app-gray-900">Configure Chains & Networks</p>
        <p class="text-sm font-normal text-app-gray-500 w-full md:w-1/2">Review chain and network settings used for Smart Accounts.</p>
      </div>
      <NoChainsAddedNotice :eip-standard="smartAccountEipStandard" />
    </div>

    <ChainsAndNetworksLayout
      v-else
      :project-id="props.project.project_id"
      :disabled="props.disabled"
      :selected-team-id="props.selectedTeamId"
      :networks="smartAccountNetworks"
      :with-network-toggle="false"
      :with-smart-account-fields="true"
      :with-add-custom-network="false"
      :smart-account-eip-standard="smartAccountEipStandard"
    >
      <template #default>
        <p class="text-sm text-app-gray-600 font-bold">Configure Chains & Networks</p>
        <p class="text-sm text-app-gray-600 w-full">Review chain and network settings used for Smart Accounts.</p>
      </template>
    </ChainsAndNetworksLayout>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";

import ChainsAndNetworksLayout from "@/components/ChainsAndNetworksLayout";
import NoChainsAddedNotice from "@/components/NoChainsAddedNotice";
import { projectModule } from "@/store";
import { DBSmartAccountsConfiguration, EipStandard, Project, UIChainConfig } from "@/utils/interface";

const props = defineProps<{
  project: Project;
  disabled: boolean;
  selectedTeamId: number;
}>();

const smartAccountNetworks = ref<UIChainConfig>([]);
// Chains & Networks tab is only unlocked after saving in General, so smartAccountConfig
// as well as the eipStandard are always set.
const smartAccountEipStandard = computed<EipStandard>(() => {
  const config: DBSmartAccountsConfiguration = JSON.parse(props.project.smart_accounts_configuration!);
  return config.eipStandard!;
});

watch(
  [() => projectModule.chainsListFromRegistry, smartAccountEipStandard],
  ([chainsListFromRegistry]) => {
    if (chainsListFromRegistry) {
      smartAccountNetworks.value = projectModule.smartAccountNetworks(props.selectedTeamId, props.project.project_id, smartAccountEipStandard.value);
    }
  },
  { immediate: true }
);
</script>
